import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { LoginForm } from '../components/auth/LoginForm';
import { RegisterForm } from '../components/auth/RegisterForm';
import { ForgotPasswordForm } from '../components/auth/ForgotPasswordForm';
import { useAuthStore } from '../store/authStore';

type AuthMode = 'login' | 'register' | 'forgot-password';

export function LoginPage() {
  const [mode, setMode] = useState<AuthMode>('login');
  const { isAuthenticated } = useAuthStore();
  const navigate = useNavigate();

  // Redirect if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleSuccess = () => {
    if (mode === 'register' || mode === 'forgot-password') {
      setMode('login');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">ISMS Manager</h1>
          <p className="text-gray-600">Information Security Management System</p>
          <p className="text-sm text-gray-500 mt-1">NIS2 Compliance Tool</p>
        </div>

        {/* Auth Forms */}
        {mode === 'login' && (
          <LoginForm
            onSuccess={() => navigate('/dashboard', { replace: true })}
            onForgotPassword={() => setMode('forgot-password')}
            onRegister={() => setMode('register')}
          />
        )}

        {mode === 'register' && (
          <RegisterForm
            onSuccess={handleSuccess}
            onLogin={() => setMode('login')}
          />
        )}

        {mode === 'forgot-password' && (
          <ForgotPasswordForm
            onBack={() => setMode('login')}
            onSuccess={handleSuccess}
          />
        )}

        {/* Footer */}
        <div className="text-center mt-8 text-xs text-gray-500">
          <p>&copy; 2025 ISMS Manager. All rights reserved.</p>
          <p className="mt-1">Built for NIS2 directive compliance</p>
        </div>
      </div>
    </div>
  );
}
